import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('belt', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5651 30.3639L4.20117 36.7279L11.2722 43.799L17.6362 37.435",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8789 19.0503L36.7281 4.20102L43.7992 11.2721L28.95 26.1213",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85855 29.6569C9.0775 28.8758 9.0775 27.6095 9.85855 26.8284L18.3438 18.3432C19.1249 17.5621 20.3912 17.5621 21.1723 18.3432L29.6575 26.8284C30.4386 27.6095 30.4386 28.8758 29.6575 29.6569L21.1723 38.1421C20.3912 38.9232 19.1249 38.9232 18.3438 38.1421L9.85855 29.6569Z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4148 22.5858L18.3438 29.6569",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7785 9.15076L38.8496 16.2218",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8283 14.1005L33.8994 21.1716",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5154 21.1716L26.8291 32.4853",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});